module.exports = __webpack_public_path__ + "ptc_momoro_A2.0b64bc60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_A2.jpg
// module id = CmKN
// module chunks = 0